import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { Text } from '@atlaskit/primitives/compiled';
import TextRenderTypeOld from './text-old';
export var TEXT_TYPE_TEST_ID = 'link-datasource-render-type--text';
var TextRenderType = function TextRenderType(_ref) {
  var text = _ref.text,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? TEXT_TYPE_TEST_ID : _ref$testId;
  if (!(text && typeof text === 'string')) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    testId: testId
  }, text), /*#__PURE__*/React.createElement("br", null));
};
var TextRenderTypeExported = function TextRenderTypeExported(props) {
  if (fg('bandicoots-compiled-migration-link-datasource')) {
    return /*#__PURE__*/React.createElement(TextRenderType, props);
  } else {
    return /*#__PURE__*/React.createElement(TextRenderTypeOld, props);
  }
};
export default TextRenderTypeExported;